import { Col, Form, Input, Row, Select } from 'antd'
import withKeyValue from 'elements/HOC/WithKeyValue'
import withSort from 'elements/HOC/withSort'
import withSpinning from 'elements/HOC/withSpinning'
import CustomDebounceSelect from 'elements/Select/CustomDebounceSelect'
import CustomSelect from 'elements/Select/CustomSelect'
import withData from 'elements/Select/withData'
import withUrlFetch from 'elements/Select/withUrlFetch'
import { GlobalContext } from 'Global'
import { get } from 'lodash'
import React from 'react'
import { compose } from 'recompose'
import CustomSpin from '../../../../elements/CustomSpin'
import { defaultFormItemLayout } from '../../../../modules/FormItems'
import { strVal } from '../../../../modules/Utils'

const MemberSelect = compose(
  withUrlFetch({
    name: 'members',
    url: 'members/list/individual?select=fn,_key,_id',
    cache: true,
    forceFetch: false,
  }),
  withSpinning,
  withSort
)(CustomDebounceSelect)

const StatusSelect = compose(
  withData({ data: ['Active', 'Suspended', 'Inactive', 'Disabled'] }),
  withKeyValue()
)(CustomSelect)

function UserManagementForm(props) {
  const { data, fetching, isNew } = props
  const { getFieldDecorator } = props.form
  const { member } = React.useContext(GlobalContext)

  return (
    <CustomSpin spinning={fetching}>
      <Form>
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Nickname">
              {getFieldDecorator('nickname', {
                initialValue: strVal(data, 'nickname'),
              })(<Input placeholder="Nickname" />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Owner">
              {getFieldDecorator('owner', {
                initialValue: strVal(data, 'owner'),
              })(<MemberSelect disabled={!isNew} valueAtr="fn" keyAtr="_id" placeholder="owner" />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Username">
              {getFieldDecorator('username', {
                initialValue: strVal(data, 'username'),
              })(<Input placeholder="Username" />)}
            </Form.Item>
          </Col>
          {isNew && (
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Password">
                {getFieldDecorator('password', {
                  initialValue: strVal(data, 'password'),
                })(<Input placeholder="Password" />)}
              </Form.Item>
            </Col>
          )}

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Google ID">
              {getFieldDecorator('google', {
                initialValue: strVal(data, 'google'),
              })(<Input placeholder="Google ID" />)}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Status">
              {getFieldDecorator('status', {
                initialValue: strVal(data, 'status'),
              })(<StatusSelect placeholder="Google ID" />)}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Tenant Groups">
              {getFieldDecorator('tenantGroups', {
                initialValue: get(data, 'tenantGroups'),
              })(
                <Select mode="tags" placeholder="Please select">
                  {member?.tenantGroups?.map((i) => (
                    <Select.Option key={i._id}>{i.name}</Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
          {/*<Col span={12}>*/}
          {/*  <Form.Item {...defaultFormItemLayout} label="MFA SMS">*/}
          {/*    {getFieldDecorator('mfa.sms', {*/}
          {/*      initialValue: strVal(data, 'mfa.sms'),*/}
          {/*    })(<Input placeholder="SMS" />)}*/}
          {/*  </Form.Item>*/}
          {/*</Col>*/}
        </Row>
      </Form>
    </CustomSpin>
  )
}

export default Form.create()(UserManagementForm)
